module.exports = __webpack_public_path__ + "img/DW_an_Beispielen.299b5b17.png";